import { inject, provideAppInitializer } from '@angular/core';
import { CABINET_TYPE } from '../constants/platform-type.constants';
import { environment } from '@shared-app-config';

/**
 * Prints the semver + build time + commit stamped by tools/version/stamp-build-info.mjs, so
 * "what version is this?" has an answer without digging into the bundle or valkey. Logged
 * unconditionally, not just in development — on production this is the first thing support asks
 * for when triaging a report. Independent of `environment.version` / `AppVersionService`: that
 * pair drives cache-busting reloads against the backend's reported version, this one is purely
 * informational.
 */
export const provideBuildInfoLog = () =>
  provideAppInitializer(() => {
    const cabinetType = inject(CABINET_TYPE);
    const { version, builtAt, commit } = environment.buildInfo;

    // eslint-disable-next-line @/no-console
    console.info(`[${cabinetType}] version ${version} · built ${builtAt} · commit ${commit}`);
  });
